import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=c1e21768&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=c1e21768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e21768",
  null
  
)

export default component.exports